import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";

export const useGetMentorMonthlySummary = (
  mentorshipId?: string,
  options?: { enabled?: boolean },
) => {
  return useQuery<any>({
    queryKey: ["mentorshipId", mentorshipId],
    enabled: options?.enabled !== false && !!mentorshipId,
    queryFn: () =>
      fetchApi({
        url: `v1/mentorships/${mentorshipId}/summary`,
        method: "GET",
      }),
    staleTime: 5 * 60 * 1000,
  });
};
